import React from 'react';
import { motion } from 'framer-motion';

const Welcome = () => {
    return (
        <section id="about" className="py-20 bg-white">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row items-center gap-12">
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="md:w-1/2"
                    >
                        <div className="relative">
                            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-4 border-l-4 border-gold-400"></div>
                            <img
                                src="https://images.unsplash.com/photo-1600607686527-6fb886090705?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                                alt="Luxury Interior"
                                className="w-full h-auto shadow-xl"
                            />
                            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-4 border-r-4 border-gold-400"></div>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="md:w-1/2"
                    >
                        <h3 className="text-gold-500 uppercase tracking-widest mb-2 font-semibold">About Us</h3>
                        <h2 className="text-4xl font-serif text-dark-900 mb-6">Welcome to Royal Standard</h2>
                        <p className="text-gray-600 mb-6 leading-relaxed">
                            At Royal Standard, we bring a touch of elegance and perfection to every project we undertake in the UAE.
                            Our commitment to quality craftsmanship and attention to detail has positioned us as a leader in premium home services.
                        </p>
                        <p className="text-gray-600 mb-8 leading-relaxed">
                            Whether it's restoring the natural beauty of your marble floors or creating custom joinery masterpieces,
                            our team of experts is dedicated to exceeding your expectations and transforming your space into a sanctuary of luxury.
                        </p>
                        <a href="#services" className="text-dark-900 border-b border-gold-400 pb-1 hover:text-gold-500 transition-colors uppercase tracking-wider text-sm">
                            Discover Our Services
                        </a>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default Welcome;
